import React, { useRef, useState} from 'react';
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { FORM, INTERNATIONAL, LB_CODE, REQUIRED } from "../../../components/i18n/i18n";
import {PH_CODE,  PH_ICON} from "../../../components/i18n/placeHolders";
import {
    FL_ICON,
    FL_ORDER,
    FL_STATUS,
} from "../../../components/i18n/formLabels";

import AfiClassLangs from "./_langs";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import TranslatedLangs from "../../../components/genericComponents/TranslatedLangs";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {afiService} from "../../../jwt/_services/hotel/afiService";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {afiClassService} from "../../../jwt/_services/hotel/afiClassService";

const AfiClassForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;


    const translatableLangs = domainObject?.translatedLangs || []
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [status, setStatus] = useState(domainObject?.status || false)

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            code: domainObject?.code,
            icon: domainObject?.icon,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                ...data,
                status: status,
                langs: langs
            }
        }

        if (!editMode)
            genericIndexedActions.save(path, afiClassService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, afiClassService, id, dataRequest)
        }
        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <Separator/>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={afiService} path={path}/>
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{LB_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                                className={(errors.code ? ' is-invalid' : '')}
                            />
                            {errors.code && <div className="invalid-feedback"
                                                 style={{'display': 'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_ICON}</Label>
                            <Input
                                type="text"
                                name="icon"
                                placeholder={PH_ICON}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_ORDER}</Label>
                            <Input
                                type="number"
                                name="showOrder"
                                min="0"
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={() => setStatus(!status)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <div className={'form-container'}>
                    <div className={''}>
                        <h2>{INTERNATIONAL}</h2>
                    </div>
                    <div className={''}>
                        <Row>
                            <Col>
                                <AfiClassLangs langs={langs}
                                               setLangs={setLangs}
                                               translatableLangs={translatableLangs}/>
                            </Col>
                        </Row>
                    </div>
                </div>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={modalRef}
                    item={domainObject}
                />
            }
        </Card>
        </Form>
    )
}


export default AfiClassForm